module.exports = __webpack_public_path__ + "img/tonga.ca554c00.png";